import React from 'react'

const Header = ({ children }) => (
  <h1>
    {children}
  </h1>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js